/**
 * NotificationPolicy - Merkezi bildirim karar sistemi
 * Tüm bildirim kararları bu merkezden yönetilir
 */

export function decideNotificationPolicy({
  type, // 'chat' | 'break' | 'calendar'
  appState, // 'foreground' | 'background'
  currentRoute, // '/chat', '/notes', ...
  activeChatId, // şu an açık sohbet
  incomingChatId, // mesaj gelen sohbet
}) {
  const isOnChatPage = currentRoute?.startsWith('/chat');

  const policy = {
    showToast: false,
    showSystem: false,
    showDropdown: false,
    showSidebarBadge: false,
    showChatStar: false,
    playSound: true,
  };

  // --------------------
  // BREAK NOTIFICATIONS
  // --------------------
  if (type === 'break') {
    if (appState === 'foreground') {
      policy.showToast = true;
    } else {
      policy.showSystem = true;
    }
    return policy;
  }

  // --------------------
  // CALENDAR NOTIFICATIONS (reminder: Windows + banner + toast hepsi)
  // --------------------
  if (type === 'calendar') {
    policy.showToast = true;
    policy.showDropdown = true;
    policy.showSystem = true;
    return policy;
  }

  // --------------------
  // CHAT NOTIFICATIONS
  // --------------------
  if (type === 'chat') {
    // App arka planda
    if (appState === 'background') {
      policy.showSystem = true;
      policy.showChatStar = true;
      return policy;
    }

    // Eğer kullanıcı sohbet ekranındaysa → toast gösterilmez
    if (isOnChatPage) {
      // Chat sekmesinde ama başka sohbet açık → sadece sidebar badge
      if (activeChatId !== incomingChatId) {
        policy.showSidebarBadge = true;
      }
      // Aynı sohbet açıksa → hiçbir şey gösterme
      return policy;
    }

    // App açık ama chat sekmesinde değil → toast göster
    policy.showToast = true;
    return policy;
  }

  return policy;
}
